import type {
  CustomerMarginConfiguration,
  CustomerMarginConfigurationDrawerEntity,
  MarginTradingOption,
  MarginTradingServerValue,
} from './types';

export function getMarginTradingOption(value: MarginTradingServerValue | undefined): MarginTradingOption | undefined {
  if (value === 'true' || value === '1') {
    return 'enabled';
  }
  if (value === 'false' || value === '0') {
    return 'disabled';
  }
  return undefined;
}

export function getCustomerMarginConfigurationDrawerEntity(
  entity: CustomerMarginConfiguration
): CustomerMarginConfigurationDrawerEntity {
  return {
    ...entity,
    MarginTrading: getMarginTradingOption(entity.MarginTrading),
  };
}

export function getCustomerMarginConfigurationEntityForSave(
  entity: CustomerMarginConfigurationDrawerEntity
): Record<string, string | undefined> {
  return {
    ...entity,
    MarginTrading:
      entity.MarginTrading === 'enabled' ? 'true' : entity.MarginTrading === 'disabled' ? 'false' : undefined,
  };
}
